import { PermissionFunctionGroup } from './permissions';

export enum HourlyQueryContextEnum {
	TABLE = 'TABLE',
	AUTOCOMPLETE = 'AUTOCOMPLETE',
}

export interface HourlyAccount {
	id?: string;
	pid?: string;
	name?: string;
	description?: string;
	facility?: {
		id: string;
		facilityName: string;
		facilityNumber: string;
	};
	organizationSettings?: {
		name?: string;
		organizationId: number;
	};
	hourlyAccountConfigs?: HourlyAccountConfig[];
}

export interface HourlyAccountUser {
	id?: number;
	active?: boolean;
	user?: {
		userId: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	hourlyAccount?: HourlyAccount;
	hourlyAccountUserGroup?: HourlyAccountUserGroup;
}

export interface HourlyAccountUserGroup {
	id?: string;
	masterPolicy?: boolean;
	hourlyAccount?: HourlyAccount;
	userGroup?: {
		name?: string;
		functionGroups: PermissionFunctionGroup[];
	};
	hourlyAccountUserGroupZonePromoCodes?: HourlyAccountUserGroupZonePromoCode[];
}

export interface HourlyAccountUserGroupZonePromoCode {
	id: string;
	webValidation: boolean;
	qrValidation: boolean;
	zonePromoCode: {
		id: number;
		facilityZone: {
			name: string;
		};
		promoCode: {
			text: string;
			rate: {
				name: string;
			};
		};
	};
}

export interface ZonePromoCode {
	id: string;
	promoCodeId: string;
	text: string;
	useLimit: number;
	useCount: number;
	startsOn: string;
	expiresOn: string;
	rateName: string;
	rateId: string;
	zoneName: string;
}

export interface HourlyAccountConfig {
	id: string;
	feature: string;
	config: string;
	createdAt: string;
	updatedAt: string;
}
